










































































import {
  defineComponent,
  computed,
  getCurrentInstance,
  onMounted,
  ref,
  onUnmounted,
  watch,
} from '@vue/composition-api';
import { CloseCircleFilledIcon, BooksIcon, CloseIcon, ChevronRightIcon } from 'tdesign-icons-vue';
import IndustryInfo from '@/renderer/components/dialog/IndustryInfo/index.vue';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import smh from '@/renderer/scripts/smh';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import i18n, { i18n_t } from '@/locales/i18n';

import {
  BusinessTypeMap,
  industryCardList,
  industryCardListIds,
  industryTypeMap,
} from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { IS_PRIVATE } from '@/common/constant';
import guideHandler, { GuideCards } from '../composition/guideHandler';
export default defineComponent({
  components: {
    CloseCircleFilledIcon,
    BooksIcon,
    CloseIcon,
    ChevronRightIcon,
    IndustryInfo,
  },
  props: {
    showNormalGuide: {
      default: false,
      type: Boolean,
    },
  },
  setup(props, context) {
    const showTips = ref<Boolean>(false);
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const { advanceGuideCards, functionGuideCards, methods: guideMethods } = guideHandler();
    const showIndustryInfo = ref(false);
    const guideList = ref<GuideCards[]>([]);
    const industryType = ref('general');
    // 判断是否不展示管理员的引导
    const closeAdminCards = computed(() => {
      // 只有当两个都操作过才会直接消失
      const { didAdmin, advanceGuideFinished } = store.getters.noviceGuidance;
      const finishedFlag = advanceGuideFinished?.slice(1).every((item: any) => item === 1);
      const didFlag = didAdmin?.didAdminCard.every((item: any) => item === 1);
      return finishedFlag || didFlag || IS_PRIVATE;
    });
    // 公有云环境，团队用户小于等于1个时在第一个卡片显示“继续组建团队”入口
    const showCreateTeam = ref(false);

    const methods = {
      emitClick(id: number) {
        // 判断是否处于引导
        const dom = document.body.querySelector('#driver-page-overlay');
        if (dom) return;
        switch (id) {
          case 1:
            reporter.report('manager_new_guide_success', {
              success_count_type: 'manager_mission',
            });
            break;
          case 2:
            reporter.report('manager_new_guide_success', {
              success_count_type: 'staff_mission',
            });
            break;
          default:
        }

        if (industryCardListIds.includes(id)) {
          industryType.value = industryTypeMap.get(id) || 'general';
          showIndustryInfo.value = true;
          return;
        }
        context.emit('openDetail', id);
        guideMethods.reportFunctionGuide(id, 'guide_dlg_show');
      },
      toFillInSurvey() {
        reporter.report('meeting_message', {
          banner: 'click',
        });
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_USER_SURVEY);
      },
      close() {
        showTips.value = false;
      },
      async setShowCreateTeam() {
        try {
          const res = await smh.userAPI.getUserList({
            keyword: '',
            page: 0,
            pageSize: 0,
          });
          // 公有云环境，团队用户小于等于1个时在第一个卡片显示“继续组建团队”入口
          showCreateTeam.value = res.data.totalNum <= 1 && !store.getters.isPrivate;
        } catch (error) {
          showCreateTeam.value = false;
          tips.error(error as MsgError);
        }
      },
      async getSurveyInfo() {
        const { userRole } = user.getUserInfo();
        const { isInWeMeetApp, editionFlag } = store.getters;
        if (editionFlag === 'personal') return;
        if (userRole !== RoleMap.SuperAdmin || !isInWeMeetApp) {
          showTips.value = false;
          return;
        }
        try {
          const { data = [] } = await smh.userAPI.getSurvey({
            type: 'create-industry-info',
          });
          if (data.length === 0) {
            showTips.value = true;
            reporter.report('meeting_message', {
              banner: 'show',
            });
            return;
          }
          showTips.value = false;
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      createTeam() {
        guideMethods.createTeam();
      },

      getAdvanceGuideCards() {
        const { bussiness, noviceGuidance } = store.getters;
        const { advanceGuideFinished } = noviceGuidance;
        // 2.6.0 版本 --> advanceGuideFinished 卡片数量新增，补充一个卡片 同时兼容之前版本的数据卡片数据)
        if (advanceGuideFinished?.length > 3) {
          // 为了避免多次push， 需要先判断这个数据是否已经存在
          const flag = advanceGuideCards.value.some(item => industryCardListIds.includes(item.id));
          if (!flag && !IS_PRIVATE) {
            advanceGuideCards.value.push({
              id: 11,
              title: i18n_t('网盘使用攻略'),
              text: i18n_t('提供一站式文件安全管理、高效办公协作、在线签合同的解决方案'),
              icon: 'industry-5',
            });
          }
        }
        const id = BusinessTypeMap.get(bussiness) || 11;
        const info = industryCardList.find(item => item.id === id);
        if (info) {
          const newList = advanceGuideCards.value.map(item => {
            if (industryCardListIds.includes(item.id)) {
              return info;
            }
            return item;
          });
          guideList.value = newList;
        }
      },
    };
    onMounted(() => {
      methods.getSurveyInfo();
      methods.setShowCreateTeam();
      guideMethods.getFunctionGuideShow();
      methods.getAdvanceGuideCards();
      ipc.on(ipc.RENDERER_EVENTS_MAP.FINISH_SURVEY, methods.close);

      // 上报展示
      functionGuideCards.value.forEach(item => {
        if (item.show) {
          guideMethods.reportFunctionGuide(item.id, 'card_show');
        }
      });
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.FINISH_SURVEY, methods.close);
    });

    watch(
      () => store.getters.bussiness,
      (val, oldval) => {
        if (val !== oldval) {
          methods.getAdvanceGuideCards();
        }
      },
    );

    watch(
      () => store.getters.noviceGuidance,
      val => {
        if (val) {
          methods.getAdvanceGuideCards();
        }
      },
    );

    return {
      industryType,
      showIndustryInfo,
      showTips,
      showCreateTeam,
      advanceGuideCards,
      guideList,
      closeAdminCards,
      functionGuideCards,
      ...methods,
      ...guideMethods,
    };
  },
});
